import { DsIcon } from '@descomplica/design-system-react';
import format from 'date-fns/format';
import React from 'react';
import styled from 'styled-components';

import type { LiveStreamingDto } from '@/application/interfaces/pegasus.gateway';

const Container = styled.a`
  position: relative;
  margin: 0px 8px;
  display: block;
  color: #ffffff;
  cursor: pointer;
`;

const ImageWrapper = styled.div`
  background: var(--gray-01);
  height: 140px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
`;

const Image = styled.img`
  width: 100%;
`;

const Name = styled.div`
  font-weight: 700;
  font-size: 16px;
  letter-spacing: -0.4px;
  padding: 8px 0 8px;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Infos = styled.div`
  display: flex;
  flex: 1;
  gap: 8px;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const InfoLabel = styled.div`
  font-weight: 400;
  font-size: 14px;
`;

const StyledDsIcon = styled(DsIcon)`
  height: 14px !important;
  width: 14px !important;
`;

const HighlightCardStatus = styled.p`
  top: 1rem;
  left: 1rem;
  position: absolute;
  gap: 0.25rem;
  display: flex;
  align-items: center;
  z-index: 4;
`;

const HighlightCardTextStatus = styled.div`
  font-family: Aprova Nova;
  font-size: 12px;
  font-weight: 400;
  line-height: 13px;
  letter-spacing: 0px;
  text-align: left;
  text-transform: uppercase;
`;

type Props = {
  live: LiveStreamingDto;
};

export enum LiveStatus {
  NEXT = 'Agendada',
  LIVE = 'Transmissão',
  RERUN = 'Reprise',
  RECORDED = 'Gravada',
}

const LiveItem: React.FC<Props> = ({ live }) => {
  const getCourseUrl = () => {
    return `/classroom/live/course/${live.course.guid}/${live.streaming.guid}`;
  };

  const handleDate = (date: Date) => format(date, "dd/MM 'às' HH:mm");
  const streamingDate = handleDate(new Date(live.streaming.startStreaming));

  const handleStreaming = (streaming: LiveStreamingDto) => {
    switch (streaming.streaming.lessonStatus) {
      case LiveStatus.NEXT:
        return 'Agendada';
      case LiveStatus.RERUN:
      case LiveStatus.RECORDED:
        return 'Assistir de novo';
      default:
        return '';
    }
  };

  const handleStreamingIcon = (streaming: LiveStreamingDto) => {
    switch (streaming.streaming.lessonStatus) {
      case LiveStatus.NEXT:
        return <StyledDsIcon image={'schedule'} color={'neutral-00'} />;
      case LiveStatus.RERUN:
      case LiveStatus.RECORDED:
        return <StyledDsIcon image={'refresh'} color={'neutral-00'} />;
      default:
        return null;
    }
  };

  return (
    <Container href={getCourseUrl()}>
      <HighlightCardStatus>
        {handleStreamingIcon(live)}
        <HighlightCardTextStatus>{handleStreaming(live)}</HighlightCardTextStatus>
      </HighlightCardStatus>
      <ImageWrapper>{live.thumbnail && <Image src={live.thumbnail} />}</ImageWrapper>
      <Name>{live.name}</Name>
      <Footer>
        <Infos>
          <InfoItem>
            <StyledDsIcon image={'calendar'} color={'neutral-00'} />
            <InfoLabel>{streamingDate}</InfoLabel>
          </InfoItem>
        </Infos>
      </Footer>
    </Container>
  );
};

export default LiveItem;
